<template>
  <div>
    <BookingBack title="Gift Card" :textColor="'#333333'" :isCenter="true" />
    <div style="width: 100%; padding: 1rem; box-sizing: border-box">
      <!-- Gift Card展示：未购买状态，不显示卡号 -->
      <GiftCardPreview v-if="detail" :cardData="detail" :clickable="false" />
      <div class="cardInfo" v-if="detail">
        <div class="valid">
          <div class="validText">Valid for:</div>
          <div class="validRemark">{{ scopeText }}</div>
        </div>
        <div class="userInfo">
          <img :src="supplierLogo" alt="" />
          <div>
            <div>{{ supplierInfo.name || 'Merchant' }}</div>
            <div class="time">{{ supplierInfo.address || 'No address' }}</div>
          </div>
        </div>
        <div class="priceBox">
          <van-divider />
          <div class="priceItem">
            <div>Price</div>
            <div class="priceNum">{{ formatCurrency(detail.price) }}</div>
          </div>
          <van-divider />
          <div class="priceItem">
            <div>Value</div>
            <div class="priceNum">{{ formatCurrency(detail.value) }}</div>
          </div>
          <van-divider />
          <div class="priceItem">
            <div>Expires after</div>
            <div class="priceNum">{{ expirationText }}</div>
          </div>
          <van-divider />
          <div>
            <div style="margin-bottom: 0.5rem">
              Gift Cards are not personalized and can be used by anyone with the card number
            </div>
            <div>
              Gift Cards are not single use and can be used as many times as necessary until the balance is fully
              consumed
            </div>
          </div>
          <van-divider />
          <div class="bottomRemark">
            <div style="margin-bottom: 0.5rem">
              After purchasing the Card, your personal data will be processed by the Partner from whom you buy card. You
              will find detailed information in Partner information
            </div>
            <div>Detailed rules for using Gift Cards can be found in the terms and conditions</div>
          </div>
        </div>
      </div>
      <van-empty v-if="!loading && !detail" description="No gift card details" />
    </div>
    <OrderBtn>
      <div class="buyBtn" @click="handleBuy">Buy Gift Card</div>
    </OrderBtn>
  </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import OrderBtn from '@/components/Order/btn.vue'
import GiftCardPreview from '@/components/GiftCard/PreviewCard.vue'
const SS_PAYMENT_HANDLED = 'giftcard_payment_handled'
export default {
  name: 'GiftCardDetail',
  components: {
    BookingBack,
    OrderBtn,
    GiftCardPreview
  },
  data() {
    return {
      detail: null,
      loading: false
    }
  },
  computed: {
    supplierInfo() {
      return (this.detail && this.detail.supplier) || {}
    },
    supplierLogo() {
      const logo = this.supplierInfo.logo && this.supplierInfo.logo.file_path
      return this.formatImagePath(logo) || 'https://pic.rmb.bdstatic.com/bjh/bc11504608c0/250314/7904a9d0b5755cec95a4bb00d8763f94.png'
    },
    scopeText() {
      if (!this.detail) return '--'
      const scope = Number(this.detail.applicable_scope)
      if (scope === 0) return 'All Services & Products'
      if (scope === 1) return 'Selected Services Only'
      return 'See Merchant Details'
    },
    expirationText() {
      if (!this.detail) return '--'
      const days = Number(this.detail.expiration_days)
      if (!days) return 'No Expiration'
      return `${days} Days From Purchase`
    }
  },
  created() {
    // Clear all Stripe-related markers to prevent navigation issues when entering detail page
    try { sessionStorage.removeItem(SS_PAYMENT_HANDLED) } catch (e) {}
    try { sessionStorage.removeItem('__stripe_skip_fix') } catch (e) {}
    try { sessionStorage.removeItem('__stripe_from_fullPath') } catch (e) {}
    try { sessionStorage.removeItem('__stripe_from_ts') } catch (e) {}
    try { sessionStorage.removeItem('__stripe_fix_pending') } catch (e) {}
    try { sessionStorage.removeItem('__stripe_return_to_fullPath') } catch (e) {}
    try { sessionStorage.removeItem('__stripe_nav_mode') } catch (e) {}
    try { sessionStorage.removeItem('giftcard_order_no') } catch (e) {}
    try { sessionStorage.removeItem('giftcard_order_id') } catch (e) {}
    try { sessionStorage.removeItem('giftcard_card_id') } catch (e) {}
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      const id = this.$route.query.card_id
      if (!id) return
      this.loading = true
      try {
        const res = await this.$api.getCardDetail({ id })
        if (res.code === 1 && res.data && res.data.detail) {
          this.detail = res.data.detail
        }
      } catch (e) {
        // ignore
      } finally {
        this.loading = false
      }
    },
    formatCurrency(value) {
      const num = Number(value || 0)
      return `$${num.toFixed(2)}`
    },
    formatImagePath(path) {
      if (!path) return ''
      let finalPath = path.trim()
      if (/^https?:/i.test(finalPath)) {
        return finalPath.replace('http://localhost:8080', 'http://www.hwm.red')
      }
      finalPath = finalPath.replace(/^\/+/, '')
      // 相对路径需要加上 /uploads/ 前缀（参考网页端的 resolveUploadUrl）
      const fullPath = finalPath.startsWith('uploads/') ? `/${finalPath}` : `/uploads/${finalPath}`
      return `http://www.hwm.red${fullPath}`
    },
    handleBuy() {
      const cardId = this.$route.query.card_id
      if (!cardId) {
        return
      }
      // Clear the payment handled flag so user can start a new payment flow
      try { sessionStorage.removeItem(SS_PAYMENT_HANDLED) } catch (e) {}
      this.$router.push({
        path: '/giftCardBuy',
        query: { card_id: cardId }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .buyBtn{
        width:100%;
        height: 2.75rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .25rem;
        background: #1E3C3E;
        color: #fff;
    }
    .cardInfo{
        .bottomRemark{
            font-size: .875rem;
            color: #999999;
        }
        .valid{
            margin-bottom: 1rem;
            .validText{
                font-size: 1.25rem;
            }
            .validRemark{
                font-size: .875rem;
                color: #666666;
                margin-top: .3125rem;
            }
        }
        .userInfo{
            font-size: .875rem;
            display: flex;
            align-items: center;
            .time{
                font-size: .75rem;
                color: #999999;
            }
            img{
                width: 2.625rem;
                height: 2.625rem;
                display: block;
                border-radius: 100%;
                margin-right: .5rem;
            }
        }
        .priceBox{
            font-size: .875rem;
            .priceItem{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .priceNum{
                    font-size: 1rem;
                    font-weight: bold;
                }
            }
        }
    }
</style>
